/* =============================================================
   Authentic Afghan Saffron — theme.js
   Lightweight, no framework. Only DOM the theme actually uses.
   ============================================================= */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector('.header__menu-toggle');
  var mobileMenu = document.getElementById('MobileMenu');
  var menuClose  = document.querySelector('.mobile-menu__close');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose)  menuClose.addEventListener('click', closeMenu);
  if (mobileMenu) {
    mobileMenu.addEventListener('click', function (e) {
      if (e.target === mobileMenu) closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ---------- Quantity selectors ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus  = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap  = (minus || plus).closest('.qty');
    if (!wrap) return;
    var input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    var v = parseInt(input.value || '1', 10);
    if (minus) v = Math.max(parseInt(input.min || '1', 10), v - 1);
    if (plus)  v = v + 1;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-src');
      var main = btn.closest('.product__gallery').querySelector('.product__media-main img');
      if (main && src) {
        main.src = src;
        main.removeAttribute('srcset');
      }
    });
  });

  /* ---------- Variant selection (no full page reload) ---------- */
  var forms = document.querySelectorAll('.product__form');
  forms.forEach(function (form) {
    var section = form.closest('[data-section-id]');
    if (!section) return;

    function getSelectedOptions() {
      var groups = form.querySelectorAll('.product__option');
      return Array.from(groups).map(function (g) {
        var checked = g.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findMatchingVariant(productData, selected) {
      if (!productData || !productData.variants) return null;
      return productData.variants.find(function (v) {
        return selected.every(function (val, i) {
          if (val == null) return true;
          return v['option' + (i + 1)] === val;
        });
      }) || null;
    }

    function updateUI(variant) {
      if (!variant) return;
      // Hidden variant id
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;

      // Displayed price + URL stay in sync with the selected variant.
      var fmt = function (cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '.00'); };
      var section = form.closest('.product') || document;
      var priceEl = section.querySelector('.product__price-row .price__regular, .product__price-row .price__sale');
      if (priceEl) {
        var label = priceEl.querySelector('.visually-hidden');
        priceEl.textContent = '';
        if (label) priceEl.appendChild(label);
        priceEl.appendChild(document.createTextNode(' ' + fmt(variant.price)));
      }
      var compareEl = section.querySelector('.product__price-row .price__compare s');
      if (compareEl && variant.compare_at_price) compareEl.textContent = fmt(variant.compare_at_price);

      // Swap the gallery hero to the selected variant's own image. Shopify sends
      // featured_image on the variant object; each size here has its own photo,
      // so without this the customer sees one picture for every size.
      var heroImg = section.querySelector('.product__media-main img');
      if (heroImg && variant.featured_image && variant.featured_image.src) {
        var vsrc = variant.featured_image.src;
        var sep = vsrc.indexOf('?') === -1 ? '?' : '&';
        var at = function (n) { return vsrc + sep + 'width=' + n; };
        heroImg.setAttribute('src', at(1400));
        heroImg.setAttribute('srcset', at(700) + ' 700w, ' + at(1100) + ' 1100w, ' + at(1600) + ' 1600w');
        if (variant.featured_image.alt) heroImg.setAttribute('alt', variant.featured_image.alt);
        // Mark the matching thumbnail active, if one corresponds.
        var base = vsrc.split('?')[0];
        section.querySelectorAll('[data-thumb]').forEach(function (tb) {
          var ds = tb.getAttribute('data-src') || '';
          tb.classList.toggle('is-active', ds.split('?')[0] === base);
        });
      }
      if (window.history && history.replaceState) {
        try { history.replaceState(null, '', window.location.pathname + '?variant=' + variant.id); } catch (e) {}
      }

      // Notify the subscription UI (and any other listener) that the variant
      // changed, so a stale per-variant selling_plan is never submitted.
      form.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant: variant } }));
      // Sticky ATC listens on document with a flat detail shape.
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: { id: variant.id, priceFormatted: fmt(variant.price) } }));

      // Selected value labels
      var groups = form.querySelectorAll('.product__option');
      groups.forEach(function (g, i) {
        var checked = g.querySelector('input[type="radio"]:checked');
        var label = g.querySelector('[data-selected-value]');
        if (checked && label) label.textContent = checked.value;
        // Active swatch state
        g.querySelectorAll('.product__swatch').forEach(function (sw) {
          var inp = sw.querySelector('input');
          sw.classList.toggle('is-active', inp && inp.checked);
        });
      });

      // Submit button availability
      var submit = form.querySelector('button[type="submit"]');
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? (submit.dataset.labelAdd || 'Add to cart') : 'Sold out';
      }
    }

    // Pull product JSON from /products/handle.json once
    var productHandle = window.location.pathname.split('/products/')[1];
    if (productHandle) {
      productHandle = productHandle.split('/')[0].split('?')[0];
      fetch('/products/' + productHandle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          form.addEventListener('change', function (e) {
            if (!e.target.matches('.product__option input[type="radio"]')) return;
            var selected = getSelectedOptions();
            var v = findMatchingVariant(data, selected);
            updateUI(v);
          });
        })
        .catch(function () { /* silent */ });
    }
  });

  /* Cart-count updates are owned by luxe-ui.js (AJAX drawer). With JS the
     drawer intercepts every /cart/add submit; without it, native submission
     navigates to /cart where the badge re-renders server-side. */
})();
